import { createReducer, on } from '@ngrx/store';
import { DeviceActiveSyncsApiActions, SignalRActions } from './devices-active-syncs.actions';
import { adapter, initialState } from './devices-active-syncs.state';

export const deviceActiveSyncsReducer = createReducer(
  initialState,
  on(
    SignalRActions.activeDeviceSyncsUpdated,
    DeviceActiveSyncsApiActions.deviceActiveSyncCountLoaded,
    (state, { currentActiveSyncs }) => adapter.setAll([currentActiveSyncs], state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectCurrentActiveDeviceSyncsIds = selectIds;

export const selectCurrentActiveDeviceSyncsEntities = selectEntities;

export const selectCurrentActiveDeviceSyncs = selectAll;
